export enum LegacyExamQuestionMarkingMode {
  Manual = 'manual',
  Criteria = 'criteria',
}

export enum LegacyExamQuestionMarkOutcome {
  Correct = 'CORRECT',
  Missed = 'MISSED',
  SillyMistake = 'SILLY',
  Inaccuracy = 'INACCURACY',
}
